export async function normalizeError(error: unknown): Promise<Error> {
  if (error instanceof Error) {
    return error;
  }

  if (error instanceof Response) {
    try {
      const errorData = await error.json();
      return new Error(
        JSON.stringify({
          status: error.status,
          statusText: error.statusText,
          details: errorData
        })
      );
    } catch {
      return new Error(`HTTP ${error.status} ${error.statusText}`);
    }
  }

  if (typeof error === "string") {
    return new Error(error);
  }

  if (typeof error === "object" && error !== null) {
    const errorObj = error as Record<string, unknown>;
    const message =
      typeof errorObj.message === "string"
        ? errorObj.message
        : "An unknown error occurred";

    const normalizedError = new Error(message);

    if (typeof errorObj.cause === "string" || errorObj.cause instanceof Error) {
      normalizedError.cause = errorObj.cause;
    }

    if (typeof errorObj.stack === "string") {
      normalizedError.stack = errorObj.stack;
    }

    return normalizedError;
  }

  return new Error(String(error));
}
